import DOMPurify from 'dompurify';
import WhiteDefaultLogo from 'images/Inspiretec_white.png';
import EmailTemplateImage from 'images/header-picture-shorter.jpg';
import { ROUTES_QUOTE_LINK } from 'shared/constants/quoteLinkRoutes';
import {
  DEFAULT_PRIMARY_COLOUR,
  DEFAULT_SECONDARY_COLOUR,
} from 'shared/constants/styleConstants';

export default function QuoteEmailTemplate() {
  const data = `
    <div style="background: rgb(24, 168, 203); height: 70px; display: flex; justify-content: center; align-items: center;">
      <img src=${WhiteDefaultLogo} alt="logo" style='max-height: 50px;' }} />
    </div>

    <div style="display: flex; justify-content: center; margin: 15px 0px; flex-wrap: wrap; gap: 1rem;">
      <div>
        <div style="display: block; border-right: 1px solid;">
          <div style="padding: 0px 20px; font-weight: 600; color: ${DEFAULT_PRIMARY_COLOUR}; text-decoration: underline; text-underline-offset: 3px;">
            Holidays
          </div>
        </div>
      </div>
      <div>
        <div style="display: block; border-right: 1px solid;">
          <div style="padding: 0px 20px; font-weight: 600; color: ${DEFAULT_PRIMARY_COLOUR}; text-decoration: underline; text-underline-offset: 3px;">
            Destinations
          </div>
        </div>
      </div>
      <div>
        <div style="display: block; border-right: 1px solid;">
          <div style="padding: 0px 20px; font-weight: 600; color: ${DEFAULT_PRIMARY_COLOUR}; text-decoration: underline; text-underline-offset: 3px;">
            Latest offers
          </div>
        </div>
      </div>
      <div>
        <div>
          <div style="padding: 0px 20px; font-weight: 600; color: ${DEFAULT_PRIMARY_COLOUR}; text-decoration: underline; text-underline-offset: 3px;">
            Cruises
          </div>
        </div>
      </div>
    </div>

    <img
      src="${window.location.hostname}${EmailTemplateImage}"
      alt="header"
      style="width: 100%; max-height: 500px;"
    />

    <div style="margin: 25px 20px;">
      <p style="margin: 15px 0px;">Dear Mr Williams</p>
      <p style="margin: 15px 0px;">
        Please find a link to your personalised holiday itinerary below:
      </p>

      <a
        target="_blank"
        rel="noreferrer"
        href=${ROUTES_QUOTE_LINK.OVERVIEW}
        style="display: flex;"
      >
        <div style="padding: 10px; background: ${DEFAULT_PRIMARY_COLOUR}; color: #fff; flex-grow: 0;">
          View your itinerary
        </div>
      </a>

      <p style="margin: 15px 0px;">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vehicula
        rhoncus sodales. Donec in facilisis magna, sit amet pulvinar metus.
        Sed a cursus nisi, quis sodales nunc. Nam fringilla, turpis quis
        ornare elementum, ante metus imperdiet mauris, in finibus magna dui
        quis felis. Nulla ut accumsan nunc. Vestibulum elementum, elit ut
        iaculis gravida, leo risus ultrices lorem, ut ornare ipsum ex id
        ligula. Ut non dictum urna, quis hendrerit felis.
      </p>

      <p style="margin: 15px 0px;">Best wishes,</p>

      <div style="margin: 15px 0px;">
        <p>Jordan Lambert</p>
        <p style="font-weight: 600;">Travel Specialist</p>
      </div>
    </div>

    <div
      style="background: ${DEFAULT_PRIMARY_COLOUR};
      display: flex;
      justify-content: center;
      border-bottom: 2px solid ${DEFAULT_SECONDARY_COLOUR};
      padding: 5px 0"
    >
      <img
        src=${WhiteDefaultLogo}
        alt="logo"
        style="max-height: 50px; margin: 10px"
      />
    </div>

    <div
      style="background: ${DEFAULT_PRIMARY_COLOUR};
      display: flex;
      justify-content: center;
      padding: 15px 0;
      flex-wrap: wrap;
      gap: 1rem"
    >
      <div>
        <div style="display: block; border-right: 1px solid ${DEFAULT_PRIMARY_COLOUR};">
          <div style="padding: 0px 20px; font-weight: 600; color: ${DEFAULT_PRIMARY_COLOUR}; text-decoration: underline; text-underline-offset: 3px;">Holiday enquiry</div>
        </div>
      </div>

      <div>
        <div style="display: block; border-right: 1px solid ${DEFAULT_PRIMARY_COLOUR};">
          <div style="padding: 0px 20px; font-weight: 600; color: ${DEFAULT_PRIMARY_COLOUR}; text-decoration: underline; text-underline-offset: 3px;">Visit website</div>
        </div>
      </div>

      <div>
        <div style="display: block; border-right: 1px solid ${DEFAULT_PRIMARY_COLOUR};">
          <div style="padding: 0px 20px; font-weight: 600; color: ${DEFAULT_PRIMARY_COLOUR}; text-decoration: underline; text-underline-offset: 3px;">About us</div>
        </div>
      </div>

      <div>
        <div
          style="display: block"
        >
          <div style="padding: 0px 20px; font-weight: 600; color: ${DEFAULT_PRIMARY_COLOUR}; text-decoration: underline; text-underline-offset: 3px;">01234567890</div>
        </div>
      </div>
    </div>

    <div
      style="
        background: ${DEFAULT_PRIMARY_COLOUR};
        display: flex;
        justify-content: center;
        padding: 5px 0;
        gap: 10px;
        "
    >
      <div
        style="position: relative; padding: 20px; color: ${DEFAULT_SECONDARY_COLOUR}; fill: ${DEFAULT_SECONDARY_COLOUR}; border-radius: 9999px; width: 30px; background: #fff"
      >
        <div style="position: absolute; width: 100%; inset: 0px; display: flex; align-items: center; justify-content: center; font-size: 1.3rem; line-height: 2rem;">
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path></svg>
        </div>
      </div>

      <div
        style="position: relative; padding: 20px; color: ${DEFAULT_SECONDARY_COLOUR}; fill: ${DEFAULT_SECONDARY_COLOUR}; border-radius: 9999px; width: 30px; background: #fff"
      >
        <div style="position: absolute; width: 100%; inset: 0px; display: flex; align-items: center; justify-content: center; font-size: 1.3rem; line-height: 2rem;">
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path></svg>
        </div>
      </div>

      <div
        style="position: relative; padding: 20px; color: ${DEFAULT_SECONDARY_COLOUR}; fill: ${DEFAULT_SECONDARY_COLOUR}; border-radius: 9999px; width: 30px; background: #fff"
      >
        <div style="position: absolute; width: 100%; inset: 0px; display: flex; align-items: center; justify-content: center; font-size: 1.3rem; line-height: 2rem;">
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"></path></svg>
        </div>
      </div>
    </div>


    <div
      style="background: ${DEFAULT_PRIMARY_COLOUR}; display: flex; justify-content: center; gap: 20px; padding-top: 15px; padding-bottom: 30px; flex-wrap: wrap;"
    >
      <div>
        <div style="display: block;">
          <div style="font-size: 13px; color: rgb(255, 255, 255); text-decoration: underline; text-underline-offset: 3px;">Contact us</div>
        </div>
      </div>

      <div>
        <div style="display: block;">
          <div style="font-size: 13px; color: rgb(255, 255, 255); text-decoration: underline; text-underline-offset: 3px;">Branch finder</div>
        </div>
      </div>

      <div>
        <div style="display: block;">
          <div style="font-size: 13px; color: rgb(255, 255, 255); text-decoration: underline; text-underline-offset: 3px;">Terms & Conditions</div>
        </div>
      </div>

      <div>
        <div style="display: block;">
          <div style="font-size: 13px; color: rgb(255, 255, 255); text-decoration: underline; text-underline-offset: 3px;">Privacy Policy</div>
        </div>
      </div>
    </div>
  `;
  const sanitizedData = () => ({
    __html: DOMPurify.sanitize(data),
  });

  return <div dangerouslySetInnerHTML={sanitizedData()} />;
}
